import { useEffect, useState } from "react";
import { Clock, Plus, Save, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, formatApiError } from "@/lib/api";

const ServiceRow = ({ s, onChanged }) => {
  const [name, setName] = useState(s.name);
  const [duration, setDuration] = useState(s.duration);
  const dirty = name !== s.name || Number(duration) !== s.duration;

  const save = async () => {
    try { await api.put(`/services/${s.id}`, { name, duration: Number(duration) }); toast.success("Serviciu actualizat"); onChanged(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const remove = async () => {
    if (!window.confirm(`Ștergi serviciul „${s.name}”?`)) return;
    try { await api.delete(`/services/${s.id}`); toast.success("Serviciu șters"); onChanged(); } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div className="grid grid-cols-[1fr_110px_auto] items-center gap-2 rounded-xl border bg-card p-3" data-testid={`service-row-${s.id}`}>
      <Input value={name} onChange={(e) => setName(e.target.value)} data-testid={`service-name-${s.id}`} />
      <div className="relative">
        <Input type="number" min="5" step="5" value={duration} onChange={(e) => setDuration(e.target.value)} className="pr-10" data-testid={`service-duration-${s.id}`} />
        <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-xs text-muted-foreground">min</span>
      </div>
      <div className="flex gap-1">
        <Button size="icon" variant={dirty ? "default" : "ghost"} disabled={!dirty} onClick={save} data-testid={`service-save-${s.id}`}><Save className="h-4 w-4" /></Button>
        <Button size="icon" variant="ghost" onClick={remove} className="text-muted-foreground hover:text-destructive" data-testid={`service-delete-${s.id}`}><Trash2 className="h-4 w-4" /></Button>
      </div>
    </div>
  );
};

export const ServicesPanel = () => {
  const [services, setServices] = useState([]);
  const [name, setName] = useState("");
  const [duration, setDuration] = useState(60);
  const load = () => api.get("/services").then((r) => setServices(r.data));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/services", { name, duration: Number(duration) }); setName(""); toast.success("Serviciu adăugat"); load(); }
    catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div className="space-y-4" data-testid="services-panel">
      <form onSubmit={add} className="grid grid-cols-[1fr_110px_auto] gap-2 rounded-xl border border-dashed p-3">
        <Input required value={name} onChange={(e) => setName(e.target.value)} placeholder="ex: Revizie centrală" data-testid="new-service-name-input" />
        <Input required type="number" min="5" step="5" value={duration} onChange={(e) => setDuration(e.target.value)} data-testid="new-service-duration-input" />
        <Button type="submit" data-testid="new-service-add-button"><Plus className="h-4 w-4" /> <span className="hidden sm:inline">Adaugă</span></Button>
      </form>
      {services.length === 0 ? (
        <p className="flex items-center gap-2 text-sm text-muted-foreground"><Clock className="h-4 w-4" /> Niciun serviciu. Adaugă primul serviciu mai sus.</p>
      ) : services.map((s) => <ServiceRow key={`${s.id}-${s.name}-${s.duration}`} s={s} onChanged={load} />)}
    </div>
  );
};
